import { WIPPanel } from "../../components/WIPPanel";
import { HelperIcon } from "../../components/icons";

export function HelperTab() {
  return (
    <WIPPanel
      icon={<HelperIcon />}
      title="AI assistance is coming in a future version"
      description="Helper is intended to become an AI assistant for managing this server. It does not do anything yet, and no AI service is connected."
    />
  );
}
